import { DocumentViewListPage } from "./_DocumentViewListPage";
import { fetchDocumentsIncoming } from "@/features/document/api";

export function DocumentIncomingPage() {
  return (
    <DocumentViewListPage
      title="Văn bản đến"
      breadcrumb="Quản lý Văn bản › Văn bản đến"
      queryKey="documents-incoming"
      fetcher={fetchDocumentsIncoming}
    />
  );
}
